// extracted by mini-css-extract-plugin
export var circleIcon = "CircleIcon-module__circleIcon___7rukC";